import { Anchor } from "#ui/link";

export function FactsetDisclaimers() {
  return (
    <div className="space-y-13px text-xs text-shade-80">
      <p>
        Quotes delayed at least 15 minutes. Market data provided by{" "}
        <Anchor
          href="https://www.factset.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Factset
        </Anchor>
        . Powered and implemented by{" "}
        <Anchor
          href="https://www.factset.com/products-data/digital-solutions"
          target="_blank"
          rel="noopener noreferrer"
        >
          FactSet Digital Solutions
        </Anchor>
        .{" "}
        <Anchor
          href="https://www.factset.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Legal Statement
        </Anchor>
        . News provided by The Associated Press and Comtex News Network.
        Economic Calendar Copyright 2020-2021 Econoday, Inc. Analyst Rating
        Changes provided by MT Newswires, a Division of MidnightTrader, Inc.
        Mutual Fund data provided by{" "}
        <Anchor
          href="http://www.morningstar.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Morningstar, Inc
        </Anchor>
        .
      </p>
      <p>
        This information alone is not intended to be investment advice, research
        or recommendation regarding securities, and does not provide a
        sufficient basis upon which to make an investment decision. This report
        does not take into account the specific investment objectives, financial
        situation or needs of any particular client and may not be suitable for
        all types of investors. Recipients should consider the contents of this
        report as a single factor in making an investment decision. Additional
        fundamental and other analyses would be required to make an investment
        decision about any individual security identified in this report No
        information contained herein should be construed as a solicitation or an
        offer to buy or sell any security or products. The information has been
        obtained from Interactive Data, a source we consider to be reliable, but
        we cannot guarantee the accuracy.
      </p>
      <p>
        Baird is exempt from the requirement to hold an Australian financial
        services license. Baird is regulated by the United States Securities and
        Exchange Commission, FINRA, and various other self-regulatory
        organizations and those laws and regulations may differ from Australian
        laws. This material has been prepared in accordance with the laws and
        regulations governing United States broker-dealers and not Australian
        laws.
      </p>
      <p>
        UK disclosure requirements for the purpose of distributing this research
        into the UK and other countries for which Robert W Baird Limited holds
        an ISD passport: This material is for distribution into the United
        Kingdom only to persons who fall within Article 19 or Article 49(2) of
        the Financial Services and Markets Act 2000 (financial promotion) order
        2001 being persons who are investment professionals and may not be
        distributed to private clients. Issued in the United Kingdom by Robert
        W. Baird Limited, which has an office at Finsbury Circus House, 15
        Finsbury Circus, London EC2M 7EB, and is a company authorized and
        regulated by the Financial Conduct Authority (&ldquo;FCA&rdquo;). For
        the purposes of the FCA requirements, this investment research report is
        classified as objective. Robert W. Baird Limited (&ldquo;RWBL&rdquo;) is
        exempt from the requirement to hold an Australian financial services
        license. RWBL is regulated by the FCA under UK laws and those laws may
        differ from Australian laws. This document has been prepared in
        accordance with FCA requirements and not Australian laws. Applicable
        disclosures regarding the equities discussed can be accessed at{" "}
        <Anchor
          href="http://www.rwbaird.com/research-insights/research/coverage/third-party-research-disclosures.aspx"
          target="_blank"
          rel="noopener noreferrer"
          className="break-all"
        >
          http://www.rwbaird.com/research-insights/research/coverage/third-party-research-disclosures.aspx
        </Anchor>
        .
      </p>
      <p>
        Performance data quoted represents past performance. Past performance
        does not guarantee future results. Investment return and principal value
        of an investment in the fund will fluctuate so that an investor&rsquo;s
        shares, when redeemed, may be worth more or less than their original
        cost. The fund&rsquo;s current performance may be lower or higher than
        the performance data quoted.
      </p>
      <p>
        Investors should consider the investment objectives, risks, charges, and
        expenses contained in the prospectus or summary prospectus of each fund
        carefully before investing. This and other information is found in the
        prospectus or summary prospectus. For a prospectus or summary
        prospectus, contact a Baird Financial Advisor or contact the fund
        company directly. Please read the prospectus or summary prospectus
        carefully before investing.
      </p>
    </div>
  );
}
